import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions.js";
import mutations from "./mutations.js";
import getters from "./getters.js";
import Ranks from "./modules/ranks/index";
import Programs from "./modules/program/index";
import Sets from "./modules/sets/index";
import User from "./modules/user/index";
import Leagues from "./modules/leagues/index";
import Clubs from "./modules/clubs/index";
import Athlete from "./modules/athlete/index";
import Drills from "./modules/drills/index";
import MeetSessions from "./modules/meetSessions/index";
import Meets from "./modules/meets/index";
import Standards from "./modules/standards/index";
import Categories from "./modules/categories/index";
import Facilities from "./modules/facility/index";
import MeetSessionEvents from "./modules/meetSessionEvents/index";
import PivotProfiles from "./modules/reportProfiles/index";
import MessageCenter from "./modules/messageCenter/index";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    zenMode: false,
    activityList: [],
    attendanceList: [],
    recordsList: [],
    search: false,
    loading: false,
    loadingDialog: false,
    error: null,
    showSnackbar: false,
    snackbarText: ""
  },
  mutations,
  actions,
  getters,
  modules: {
    Ranks,
    Sets,
    Leagues,
    Clubs,
    User,
    Athlete,
    Drills,
    Meets,
    Standards,
    Categories,
    Facilities,
    MeetSessions,
    MeetSessionEvents,
    PivotProfiles,
    Programs,
    MessageCenter
  }
});
